/**
 * Чек-лист: готовность отдела продаж к Generative AI
 * Маршрут: /ready-for-ai-sales
 */
export const salesChecklistData = {
  blocks: [
    {
      id: 1,
      title: 'Процессы',
      description: 'Насколько отлажены процессы создания продающих материалов и есть ли готовые шаблоны',
      icon: 0,
      questions: [
        { id: 1, text: 'Есть ли в отделе продаж утверждённые шаблоны коммерческих предложений?' },
        { id: 2, text: 'Используют ли менеджеры типовые шаблоны писем для первичного и повторного контакта?' },
        { id: 3, text: 'Есть ли документированные скрипты или сценарии разговора с клиентом?' },
        { id: 4, text: 'Есть ли процесс согласования материалов перед отправкой клиенту?' },
      ],
    },
    {
      id: 2,
      title: 'Команда',
      description: 'Насколько команда открыта к новым технологиям и есть ли базовые навыки',
      icon: 1,
      questions: [
        { id: 5, text: 'Менеджеры умеют работать в CRM и заносить данные о клиентах?' },
        { id: 6, text: 'Есть ли в команде 1-2 человека, которые любят новые технологии?' },
        { id: 7, text: 'Готовы ли сотрудники потратить 2-3 часа на обучение работе с ИИ?' },
        { id: 8, text: 'Есть ли в команде человек, который может стать администратором ИИ-инструментов?' },
        { id: 9, text: 'Обсуждали ли в команде возможности ИИ для продаж?' },
      ],
    },
    {
      id: 3,
      title: 'Инструменты',
      description: 'Техническая готовность: CRM, почта, доступ к сервисам',
      icon: 2,
      questions: [
        { id: 10, text: 'Используется ли CRM-система (amoCRM, Битрикс24, другое)?' },
        { id: 11, text: 'Есть ли корпоративная почта или мессенджер для рабочих переписок?' },
        { id: 12, text: 'Возможно ли установить браузерные расширения или дополнительные программы?' },
      ],
    },
    {
      id: 4,
      title: 'Контент',
      description: 'Объём и регулярность создания продающего контента',
      icon: 3,
      questions: [
        { id: 13, text: 'Сколько писем в месяц отправляет отдел? (шкала: 1 ≈ 10 писем, 10 ≈ 100)' },
        { id: 14, text: 'Сколько КП в месяц готовите? (шкала: 1 ≈ 10 КП, 10 ≈ 100)' },
        { id: 15, text: 'Делаете ли презентации или рекламные материалы (картинки, баннеры)?' },
        { id: 16, text: 'Снимаете ли видео для клиентов (демо, ответы на вопросы)?' },
        { id: 17, text: 'Есть ли потребность в персонализированных материалах для VIP-клиентов?' },
        { id: 18, text: 'Создаёте ли контент для соцсетей (посты, статьи)?' },
      ],
    },
    {
      id: 5,
      title: 'Бюджет',
      description: 'Готовность инвестировать в инструменты и обучение',
      icon: 4,
      questions: [
        { id: 19, text: 'Есть ли в бюджете статья на инструменты для отдела продаж?' },
        { id: 20, text: 'Рассматривали ли бюджет на обучение команды (хотя бы 10-20 тыс. ₽)?' },
        { id: 21, text: 'Есть ли понимание, что ИИ - инструмент, а не волшебная таблетка?' },
        { id: 22, text: 'Готовы ли выделить время сотрудников на тестирование (1-2 недели)?' },
        { id: 23, text: 'Есть ли поддержка руководителя в экспериментах с новыми инструментами?' },
      ],
    },
  ],
};

export const salesChecklistMeta = {
  questionCount: 23,
  maxScore: 230,
  scaleMax: 10,
};
